import { Sector } from 'recharts'

import {
  CHART_PERCENT_MAX,
  CHART_VALUE_SEPARATOR,
  PIE_ACTIVE_SECTOR_GROWTH,
} from './Chart.constants'
import { ChartLegendText } from './ChartLegendText'

export function getChartValueShare(value, total) {
  return total ? Math.round((value / total) * CHART_PERCENT_MAX) : 0
}

export function getChartValueWithShare(value, total) {
  return `${value}${CHART_VALUE_SEPARATOR}${getChartValueShare(value, total)}%`
}

export function getChartItemColor({ colors, index, item }) {
  return item.color ?? colors[index % colors.length]
}

export function renderChartLegendText(value) {
  return <ChartLegendText>{value}</ChartLegendText>
}

export function renderChartPieActiveSector({
  innerRadius,
  outerRadius,
  ...restProps
}) {
  return (
    <Sector
      {...restProps}
      innerRadius={innerRadius - PIE_ACTIVE_SECTOR_GROWTH}
      outerRadius={outerRadius + PIE_ACTIVE_SECTOR_GROWTH}
    />
  )
}
